// @flow
import {
  startDate as startDateField,
  endDate as endDateField,
  ugcId,
  ugcTypeFieldName,
} from './config/fields.config';

export function buildQueryObject(ugc: Ugc): { [string]: string } {
  const { ugc_id, ugctype, created_date } = ugc;
  const dt = created_date && created_date.split(/\s|T/).shift();

  return {
    [ugcId.name]: ugc_id,
    [ugcTypeFieldName]: ugctype,
    [startDateField.name]: dt,
    [endDateField.name]: dt,
  };
}

export default function buildQueryParams(ugc: Ugc) {
  const args = buildQueryObject(ugc);

  return Object.keys(args)
    .map(key => key + '=' + args[key])
    .join('&');
}



// WEBPACK FOOTER //
// ./src/containers/search/SearchForm/ugcSearchQuery.js